import React, { CSSProperties } from "react";
import colors from "../styles/colors";
import { Box } from "@amzn/awsui-components-react";

const footerStyle: CSSProperties = {
  paddingTop: "15px",
  paddingBottom: "15px",
  width: "100%",
  borderTop: "1px solid #eaeded",
  textAlign: "center",
  backgroundColor: colors.lightContainerBackground,
};

const footerLinkStyle: CSSProperties = {
  padding: "0px",
  fontSize: "14px",
  color: colors.linkTextColor,
  cursor: "pointer",
};

const openInNewTab = (url: string) => {
  window.open(url, "_blank");
};

const navigateToUserDocs = () => {
  openInNewTab(
    "https://w.amazon.com/bin/view/PSLM/Working_with_us/ASIN_Central/"
  );
};

function Footer() {
  return (
    <div
      id="app-footer"
      style={footerStyle}
      className="awsui awsui-polaris-dark-mode"
    >
      <Box>
        <div>
          <span style={footerLinkStyle} onClick={navigateToUserDocs}>
            Devices ASIN Central Wiki
          </span>
        </div>
      </Box>
    </div>
  );
}

export default Footer;
